import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import ReactGA from 'react-ga4';
import { API_ROOT } from './apiConfig';
import { getDateOffset } from './accountSettings';
import UserDataAccess from '../services/userDataAccess';
import { STORAGE_KEYS } from "../components/constants/StorageKeys";


const userDataAccess = new UserDataAccess();

export default class Auth {


    async exchangeTokenLogin(subjectToken) {
        return await this.processToken({
            'subject_token': subjectToken,
            'grant_type': 'token_exchange'
        });

    }

    setSSOIdentity(username) {
        localStorage.setItem(STORAGE_KEYS.SSO_IDENTITY, username);
    }

    getSSOIdentity(username) {
        return localStorage.getItem(STORAGE_KEYS.SSO_IDENTITY) || "";
    }

    setScheme(scheme) {
        localStorage.setItem(STORAGE_KEYS.SCHEME, scheme);
    }

    getScheme() {
        return localStorage.getItem(STORAGE_KEYS.SCHEME);
    }

    login(username, password) {

        return this.processToken({
            'username': username,
            'password': password,
            'grant_type': 'password'
        });

    }

    async processToken(authParams) {

        return new Promise((resolve, reject) => {
            axios.post(`${API_ROOT}/token`,
                qs.stringify(authParams), {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }).then(function (response) {
                    let expiresAt = JSON.stringify((response.data.expires_in * 1000) + new Date().getTime());
                    sessionStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, response.data.access_token);
                    sessionStorage.setItem(STORAGE_KEYS.EXPIRES_AT, expiresAt);
                    sessionStorage.setItem(STORAGE_KEYS.PASSWORD_EXPIRES_IN, response.data.pwd_expires_in);
                    axios.get(`${API_ROOT}/api/v1/users/me`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${response.data.access_token}`
                            }
                        }).then(function (userResponse) {
                            let gaUser = '';
                            sessionStorage.setItem(STORAGE_KEYS.HOME_ACCOUNT, userResponse.data.Account);
                            sessionStorage.setItem(STORAGE_KEYS.SEC_ARCHIVE, userResponse.data.secArchive);
                            sessionStorage.setItem(STORAGE_KEYS.SEC_MARK_READ, userResponse.data.secMarkRead);
                            sessionStorage.setItem(STORAGE_KEYS.SEC_SAVE, userResponse.data.secSave);
                            sessionStorage.setItem(STORAGE_KEYS.SEC_SIGN, userResponse.data.secSign);
                            sessionStorage.setItem(STORAGE_KEYS.Name, userResponse.data.Name);
                            sessionStorage.setItem(STORAGE_KEYS.USER_NAME, userResponse.data.UserName);
                            sessionStorage.setItem(STORAGE_KEYS.USER_TYPE, userResponse.data.UserType);
                            sessionStorage.setItem(STORAGE_KEYS.EMAIL, userResponse.data.Email);
                            sessionStorage.setItem(STORAGE_KEYS.DICTATOR_ID, userResponse.data.DictatorId);
                            sessionStorage.setItem(STORAGE_KEYS.ROLES, JSON.stringify(userResponse.data.Roles));
                            sessionStorage.setItem(STORAGE_KEYS.SSO_IDENTITY, userResponse.data.SSOIdentity);
                            if (userResponse.data.DictatorId) {
                                sessionStorage.setItem(STORAGE_KEYS.IS_VALID_LOGIN, true);
                                gaUser = userResponse.data.UserName;
                            }
                            else {
                                sessionStorage.setItem(STORAGE_KEYS.IS_VALID_LOGIN, userResponse.data.IdentityMode > 0);
                                gaUser = `${userResponse.data.Account}_${userResponse.data.LUID}`;
                            }

                            sessionStorage.setItem(STORAGE_KEYS.GA_USER_ID, gaUser);

                            if (userResponse.data.AuthorizedAccounts !== null && userResponse.data.AuthorizedAccounts.length) {

                                sessionStorage.setItem(STORAGE_KEYS.CENTER_NAME, userResponse.data.AuthorizedAccounts[0].Facility);
                                sessionStorage.setItem(STORAGE_KEYS.ACTIVE_ACCOUNT, userResponse.data.AuthorizedAccounts[0].Account);
                                userDataAccess.getIsCodingUser(userResponse.data.AuthorizedAccounts[0].Account).then(response => {
                                    sessionStorage.setItem(STORAGE_KEYS.IS_CODING, response);
                                })
                                if (userResponse.data.AuthorizedAccounts.length > 1) {
                                    sessionStorage.setItem(STORAGE_KEYS.CAN_SWITCH_ACCOUNTS, "true");
                                    sessionStorage.setItem(STORAGE_KEYS.USER_ACCOUNTS, JSON.stringify(userResponse.data.AuthorizedAccounts));
                                }
                                else {
                                    sessionStorage.setItem(STORAGE_KEYS.CAN_SWITCH_ACCOUNTS, "false");
                                }
                            }

                            ReactGA.set({ "user_id": gaUser });
                            ReactGA.event({
                                category: `${gaUser}`,
                                action: 'Login',
                                label: 'signin'
                            });
                            getDateOffset(userResponse.data.Account).then(response => {
                                //console.log(userResponse);

                                sessionStorage.setItem(STORAGE_KEYS.FROM_DATE, moment().subtract(response, 'days').format("MM/DD/YYYY"));
                                sessionStorage.setItem(STORAGE_KEYS.TO_DATE, moment().format("MM/DD/YYYY"));
                                
                                resolve(true);

                            })

                            
                        });
                }).catch(error => {
                    reject(error);
                });
        });
    }
   
    isInRole(role){

        var hasRole = false;
        switch (role) {
            case STORAGE_KEYS.ARCHIVE:
                hasRole = sessionStorage.getItem(STORAGE_KEYS.SEC_ARCHIVE) === 'true';
                break;
            case STORAGE_KEYS.MARK_READ:
                hasRole = sessionStorage.getItem(STORAGE_KEYS.SEC_MARK_READ) === 'true';
                break;
            case STORAGE_KEYS.SAVE:
                hasRole = sessionStorage.getItem(STORAGE_KEYS.SEC_SAVE) === 'true';
                break;
            case STORAGE_KEYS.SIGN:
                hasRole = sessionStorage.getItem(STORAGE_KEYS.SEC_SIGN) === 'true';
                break;
            case STORAGE_KEYS.ADMIN:
                hasRole = sessionStorage.getItem(STORAGE_KEYS.HOME_ACCOUNT) === '998';
                break;
            case STORAGE_KEYS.FACILITY_ADMIN:
                let roles = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.ROLES));
                hasRole = roles.indexOf(STORAGE_KEYS.ADMINISTRATOR) > -1 || roles.indexOf(STORAGE_KEYS.SUPPORT_ADMIN) > -1;
                break;
            case STORAGE_KEYS.ADD_EDIT_USER:
                let rolesSuper = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.ROLES));
                if (this.getActiveAccount() == "998") {
                    if (rolesSuper.indexOf(STORAGE_KEYS.SERVER_ADMIN) > -1)
                        hasRole = true;
                    else
                        hasRole = false;
                }
                else
                    hasRole = true;
                break;
            case STORAGE_KEYS.EDITOR:
                if (sessionStorage.getItem(STORAGE_KEYS.SEC_MARK_READ) === 'true' && sessionStorage.getItem(STORAGE_KEYS.SEC_SAVE) === 'true')
                    hasRole = true;
                break;
            case STORAGE_KEYS.SUPPORT_ADMIN:
                const saRoleCheck = sessionStorage.getItem(STORAGE_KEYS.ROLES);
                if (saRoleCheck && JSON.parse(sessionStorage.getItem(STORAGE_KEYS.ROLES)).indexOf(STORAGE_KEYS.SUPPORT_ADMIN) > -1)
                    hasRole = true;
                break;
            case STORAGE_KEYS.CODING_EDITOR:
                const ceRoleCheck = sessionStorage.getItem(STORAGE_KEYS.ROLES);
                if (ceRoleCheck && JSON.parse(sessionStorage.getItem(STORAGE_KEYS.ROLES)).indexOf(STORAGE_KEYS.CODING_EDITOR) > -1)
                    hasRole = true;
                break;                    
            default:
                hasRole = false;
        }
        return hasRole;
    }

    isAuthenticated() {

        var expiresAt = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.EXPIRES_AT) || '{}');
        return new Date().getTime() < expiresAt;
    }

    setIsCoding = async (Account) => {
        await userDataAccess.getIsCodingUser(Account).then(response => {
            sessionStorage.setItem(STORAGE_KEYS.IS_CODING, response);
        })
    }
    getIsCoding() {
        return sessionStorage.getItem(STORAGE_KEYS.IS_CODING);
    }

    isPasswordExpired() {
        var expiresAt = parseInt(sessionStorage.getItem(STORAGE_KEYS.PASSWORD_EXPIRES_IN));
        return expiresAt <= 0;
    }

    getPasswordExpiresIn() {
        return parseInt(sessionStorage.getItem(STORAGE_KEYS.PASSWORD_EXPIRES_IN));
    }

    clearPasswordExpExpiresIn() {
        sessionStorage.setItem(STORAGE_KEYS.PASSWORD_EXPIRES_IN,180);
    }

    saveUserLogin(userName) {
        sessionStorage.setItem(STORAGE_KEYS.SN_USER, userName);
    }

    getUserLogin() {
        return sessionStorage.getItem(STORAGE_KEYS.SN_USER);
    }

    getGaUser() {

        return sessionStorage.getItem(STORAGE_KEYS.GA_USER_ID);
    }

    getUserName() {
        return sessionStorage.getItem(STORAGE_KEYS.USER_NAME);
    }

    getUserEmail() {
        return sessionStorage.getItem(STORAGE_KEYS.EMAIL);
    }

    getUserId() {
        return sessionStorage.getItem(STORAGE_KEYS.USER_ID);
    }
    getSSOIdentityColumn() {
        return sessionStorage.getItem(STORAGE_KEYS.SSO_IDENTITY_COLUMN);
    }
    getUserType() {
        return sessionStorage.getItem(STORAGE_KEYS.USER_TYPE);
    }
    getFromDate() {
        return sessionStorage.getItem(STORAGE_KEYS.FROM_DATE);
    }
    getToDate() {
        return sessionStorage.getItem(STORAGE_KEYS.TO_DATE);
    }
    isValidLogin() {
        return sessionStorage.getItem(STORAGE_KEYS.IS_VALID_LOGIN) === "true";
    }
    setValidLogin(valid) {
        return sessionStorage.setItem(STORAGE_KEYS.IS_VALID_LOGIN, valid);
    }
    setFromDate(value) {
        sessionStorage.setItem(STORAGE_KEYS.FROM_DATE, value);
    }
    setToDate(value) {
        sessionStorage.setItem(STORAGE_KEYS.TO_DATE, value);
    }

    getDictatorId() {
        return sessionStorage.getItem(STORAGE_KEYS.DICTATOR_ID);
    }
    getActiveAccount() {
        return sessionStorage.getItem(STORAGE_KEYS.ACTIVE_ACCOUNT);
    }
    getHomeAccount() {
        return sessionStorage.getItem(STORAGE_KEYS.HOME_ACCOUNT);
    }
    setActiveAccount(account) {
        return sessionStorage.setItem(STORAGE_KEYS.ACTIVE_ACCOUNT, account);
    }

    setCanViewDocumentUpload(canViewDocumentUpload) {
        sessionStorage.setItem(STORAGE_KEYS.CAN_VIEW_DOCUMENT_UPLOAD, canViewDocumentUpload);
    }

    getUserAccounts() {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEYS.USER_ACCOUNTS) || '[{}]');
    }

    getCenterName() {
        return sessionStorage.getItem(STORAGE_KEYS.CENTER_NAME);
    }

    canSwitchAccounts() {
        return sessionStorage.getItem(STORAGE_KEYS.CAN_SWITCH_ACCOUNTS);
    }

    canViewDocumentUpload() {
        return sessionStorage.getItem(STORAGE_KEYS.CAN_VIEW_DOCUMENT_UPLOAD);
    }

    getToken() {
        // Retrieves the user token from localStorage
        return sessionStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    }

    isFacilityAdminFor(account) {

        if (this.isInRole(STORAGE_KEYS.FACILITY_ADMIN)) {


            var data = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.USER_ACCOUNTS) || '[{"Account": "' + this.getHomeAccount() + '"}]');
            const item = data.find(item => item.Account == account);

            if (item)
                return true;
            else
                return false;
        }

        return false;
    }

    signOut(reload = true) {
        // Clear user token and profile data from localStorage
        //const history = createBrowserHistory();
        sessionStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        sessionStorage.removeItem(STORAGE_KEYS.EXPIRES_AT);
        sessionStorage.removeItem(STORAGE_KEYS.PASSWORD_EXPIRES_IN);
        sessionStorage.removeItem(STORAGE_KEYS.GA_USER_ID);
        sessionStorage.removeItem(STORAGE_KEYS.SSO_IDENTITY);
        sessionStorage.removeItem(STORAGE_KEYS.IS_VALID_LOGIN);
        sessionStorage.removeItem(STORAGE_KEYS.EMAIL);
        sessionStorage.removeItem(STORAGE_KEYS.SSO_IDENTITY_COLUMN);
        sessionStorage.removeItem(STORAGE_KEYS.USER_ID);
        sessionStorage.removeItem(STORAGE_KEYS.SEC_SIGN);
        //location.reload(true);
        //history.replace('/');

        axios.get(`api/Logoff?scheme=${this.getScheme()}`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                if (reload) {
                    window.location.reload();
                }

            }).catch(error => {
                if (reload) {
                    window.location.reload();
                }
            });
     

    }

 
    markNotificationsRead(notifications) {

        var userKey = sessionStorage.getItem(STORAGE_KEYS.GA_USER_ID);
        var readNotifications = localStorage.getItem(`${userKey}_readNotifications`) != null ? JSON.parse(localStorage.getItem("readNotifications")) : [];
        if (!Array.isArray(readNotifications)) {
            readNotifications = [];
        }

        for (var i = 0; i < notifications.length; i++) {

            if (!notifications[i].IsRead) {
                notifications[i].IsRead = true;
                readNotifications.push(notifications[i].NotificationId);

                ReactGA.event({
                    action: 'NotificationRead',
                    category: `${userKey}_${notifications[i].NotificationId}`
                });
            }
        }
        localStorage.setItem(`${userKey}_readNotifications`, JSON.stringify(readNotifications));
        
        return notifications;
    }

    getNotifications() {

        return new Promise((resolve, reject) => {
            axios.get(`${API_ROOT}/api/v1/Users/Notifications`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${sessionStorage.getItem('access_token')}`
                    }
                }).then(function (response) {

                    var userKey = sessionStorage.getItem(STORAGE_KEYS.GA_USER_ID);
                    var readNotifications = localStorage.getItem(`${userKey}_readNotifications`) != null ? JSON.parse(localStorage.getItem(`${userKey}_readNotifications`)) : [];
                    if (!Array.isArray(readNotifications)) {
                        readNotifications = [];
                    }
                    
                    const notifications = response.data.map((notification, i) => {
                        const result = Object.assign({}, notification,
                            {
                                Url: decodeURIComponent(notification.Url),
                                IsRead: readNotifications.indexOf(notification.NotificationId) > -1
                            });

                        return result;
                    });

                    resolve(notifications);
                })
                .catch(error => {
                });
        });

    }

}


// WEBPACK FOOTER //
// ./src/services/auth.js